export default __webpack_public_path__ + "static/IBMPlexSans-Regular-Latin1-cf8cdfc9a1ead9d332f5c153dfd26efd.woff2";